var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[(
            _vm.vilkenroll === _vm.VilkenRoll.MYNDIGHET ||
            (_vm.vilkenroll === _vm.VilkenRoll.PRIVATPERSON && _vm.villDuVaraAnonym === _vm.Anonym.NEJ)
        )?_c('anmalare-sammanstallning'):_vm._e(),(_vm.misstanke === _vm.DinMisstanke.PRIVATPERSON)?_c('privatperson-sammanstallning'):_vm._e(),(_vm.misstanke === _vm.DinMisstanke.FORETAG)?_c('foretag-sammanstallning'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }